import { render, staticRenderFns } from "./PartnersKeysCreateEditForm.vue?vue&type=template&id=077e8a9e&"
import script from "./PartnersKeysCreateEditForm.vue?vue&type=script&lang=js&"
export * from "./PartnersKeysCreateEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports